import React from "react";
import { motion } from "framer-motion";

export function KPICard({ label, value, sublabel, icon: Icon, accent = "primary", testid, delay = 0 }) {
  const accentClasses = {
    primary: "text-primary bg-primary/10 border-primary/20",
    success: "text-[hsl(var(--success))] bg-[hsl(var(--success))]/10 border-[hsl(var(--success))]/25",
    destructive: "text-destructive bg-destructive/10 border-destructive/25",
    muted: "text-muted-foreground bg-muted/40 border-border",
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay, ease: "easeOut" }}
      className="card-surface p-4 flex flex-col gap-2"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <span className="overline">{label}</span>
        {Icon && (
          <div className={`h-8 w-8 rounded-md border flex items-center justify-center ${accentClasses[accent]}`}>
            <Icon className="h-4 w-4" strokeWidth={2} />
          </div>
        )}
      </div>
      <div className="num text-lg sm:text-xl md:text-2xl lg:text-3xl font-manrope font-extrabold text-foreground">{value}</div>
      {sublabel && <div className="text-xs text-muted-foreground">{sublabel}</div>}
    </motion.div>
  );
}
